import { WorkflowCustomStage } from 'api-clients/monolith';
import React, { useContext, VFC } from 'react';
import { useSelector } from 'react-redux';

import {
  makeScoreCardTemplatesEnabled,
  makeUniversalRecruiterDashboardEnabled,
} from 'containers/Auth_old/selectors';
import { IdleMoveRule } from 'containers/WorkflowEditor/components/IdleMoveRule';
import { ReviewStage } from 'containers/WorkflowEditor/components/ReviewStage';
import { Rules } from 'containers/WorkflowEditor/components/Rules';
import { StageSection } from 'containers/WorkflowEditor/components/StageSection';
import { StageSettingMessageCard } from 'containers/WorkflowEditor/components/StageSettingMessageCard';
import { StageContext } from 'containers/WorkflowEditor/contexts/stageContext';

import { ScorecardCard } from '../ScorecardCard';
import { AdvancedSettings } from './AdvancedSettings';

export const CustomStage: VFC<{ stage: WorkflowCustomStage }> = ({ stage }) => {
  const { setStage } = useContext(StageContext);
  const isSubstage = stage.parent_stage_id;
  const universalRecruiterDashboardEnabled = useSelector(
    makeUniversalRecruiterDashboardEnabled(),
  );
  const scoreCardTemplatesEnabled = useSelector(
    makeScoreCardTemplatesEnabled(),
  );

  return (
    <div data-testid="customStage">
      {!isSubstage && (
        <>
          {universalRecruiterDashboardEnabled && (
            <StageSection>
              <ReviewStage stage={stage} />
            </StageSection>
          )}
          {scoreCardTemplatesEnabled && (
            <StageSection>
              <ScorecardCard stage={stage} setStage={setStage} />
            </StageSection>
          )}
          <StageSection>
            <Rules stage={stage} />
          </StageSection>
          <StageSection>
            <IdleMoveRule stage={stage} />
          </StageSection>
          <StageSection>
            <StageSettingMessageCard
              messageType="automated"
              stageExternalId={stage.external_id}
            />
          </StageSection>
          <StageSection>
            <StageSettingMessageCard
              messageType="trigger"
              stageExternalId={stage.external_id}
            />
          </StageSection>
        </>
      )}
      <StageSection>
        <AdvancedSettings stage={stage} />
      </StageSection>
    </div>
  );
};
